import { STATUS_LABELS } from "../../lib/api";
import { itemsLabel } from "../../lib/products";
import { DeliveryCell } from "./DeliveryCell";

const tone = {
  pending_payment: "text-amber-300 border-amber-400/40 bg-amber-400/10",
  paid: "text-emerald-300 border-emerald-400/40 bg-emerald-400/10",
  packed: "text-sky-300 border-sky-400/40 bg-sky-400/10",
  delivered: "text-stone-200 border-stone-400/40 bg-stone-400/10",
  cancelled: "text-rose-300 border-rose-400/40 bg-rose-400/10",
};

export const OrdersTable = ({ orders, onStatus, onDelivery }) => (
  <div className="mt-6 overflow-x-auto rounded-3xl border border-white/10" data-testid="admin-orders-table">
    <table className="w-full min-w-[1040px] text-left text-sm">
      <thead className="bg-[#161D17] font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--sage)]">
        <tr>{["Ref", "Customer", "Address", "Delivery", "Items", "Total", "Status"].map((h) => <th key={h} className="px-5 py-4 font-normal">{h}</th>)}</tr>
      </thead>
      <tbody>
        {orders.length === 0 && (
          <tr><td colSpan={7} className="px-5 py-16 text-center text-[var(--sage)]" data-testid="admin-orders-empty">No orders yet.</td></tr>
        )}
        {orders.map((o) => (
          <tr key={o.id} className="border-t border-white/10 align-top" data-testid={`admin-order-row-${o.ref}`}>
            <td className="px-5 py-4 font-mono font-semibold text-[var(--gold)]">
              {o.ref}
              {o.subscription_ref && <span className="mt-1 block w-max rounded-full border border-emerald-400/40 px-2 py-0.5 text-[10px] font-normal capitalize text-emerald-300" data-testid={`admin-order-sub-badge-${o.ref}`}>{o.frequency}</span>}
            </td>
            <td className="px-5 py-4">
              <p className="font-semibold">{o.name}</p>
              <p className="text-[var(--sage)]">{o.email}</p>
              <p className="text-[var(--sage)]">{o.phone}</p>
            </td>
            <td className="px-5 py-4">
              <p>{o.address}</p>
              <p className="text-[var(--sage)]">{o.suburb}</p>
              {o.notes && <p className="mt-1 max-w-[220px] text-xs italic text-[var(--sage)]">“{o.notes}”</p>}
            </td>
            <td className="px-5 py-4"><DeliveryCell order={o} onSet={onDelivery} /></td>
            <td className="px-5 py-4">{itemsLabel(o).map((l) => <p key={l} className="whitespace-nowrap">{l}</p>)}</td>
            <td className="px-5 py-4 font-semibold">${Number(o.total ?? 0).toFixed(2)}</td>
            <td className="px-5 py-4">
              <select value={o.status} onChange={(e) => onStatus(o.id, e.target.value)} className={`rounded-full border px-3 py-1.5 text-xs font-semibold outline-none ${tone[o.status] ?? ""}`} data-testid={`admin-order-status-select-${o.ref}`}>
                {Object.entries(STATUS_LABELS).map(([k, v]) => <option key={k} value={k} className="bg-[#0F1410] text-white">{v}</option>)}
              </select>
              <p className="mt-2 text-xs text-[var(--sage)]">{o.created_at ? new Date(o.created_at).toLocaleDateString("en-NZ") : ""}</p>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
